var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._b({},'v-row',[_vm.$attrs],false),[_c('v-col',{attrs:{"cols":"12"}},[_c('h4',{staticClass:"primary--text mb-2"},[_vm._v(_vm._s(_vm.title))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }